import { render, staticRenderFns } from "./GetAccountBalance.vue?vue&type=template&id=3d9a2f04&scoped=true&"
import script from "./GetAccountBalance.vue?vue&type=script&lang=js&"
export * from "./GetAccountBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9a2f04",
  null
  
)

export default component.exports